import { useState, type DependencyList, type Dispatch, type SetStateAction } from 'react'
import { useEffectAfterMount } from './useEffectAfterMount'

// Replacement of useState combined with useEffectAfterMount since the same pattern is used often.
// This will remove the need for having dublet of code to build the state via e.g.
//
// const [shownAdults, setShownAdults] = useState(toArray<Adult>(props.adults))
// useEffectAfterMount(() => {
//     setShownAdults(toArray<Adult>(props.adults).map(adult => adult.id))
// }, [props.adults])
//
// But instead change it to
// const [shownAdults, setShownAdults] = useSyncedState(() => toArray<Adult>(props.adults).map(adult => adult.id), [props.adults])
// or
// const [shownAdults, setShownAdults] = useSyncedState(toArray<Adult>(props.adults).map(adult => adult.id), [props.adults])

export function useSyncedState<T>(value: ((prevT?: T) => T) | T, deps?: DependencyList): readonly [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState<T>(value)

  useEffectAfterMount(() => {
    setState(value)
  }, deps ?? [value])

  return [state, setState] as const
}
